import classNames from 'classnames';
import { useGlobalModules } from 'contexts';
import styles from './holdAndShine.module.scss';

const HoldAndShine = ({ holdFactor, shineFactor }) => {
  const globalModules = useGlobalModules();
  const { shineFactorTitle, holdFactorTitle } = globalModules.translations.product;

  const getIcon = filled => (
    <div className={classNames(styles.squareIcon, { [styles.squareIconFilled]: filled })} />
  );

  const getRating = factor => {
    const icons = [];
    for (let i = 1; i <= 3; i += 1) {
      icons.push(getIcon(i <= factor));
    }

    return <div className={styles.iconsContainer}>{icons}</div>;
  };

  return (
    <div className={styles.container}>
      {holdFactor !== null && (
        <>
          <p className={styles.title}>{holdFactorTitle}</p>
          {getRating(holdFactor)}
        </>
      )}
      {shineFactor !== null && (
        <>
          <p className={styles.title}>{shineFactorTitle}</p>
          {getRating(shineFactor)}
        </>
      )}
    </div>
  );
};

export default HoldAndShine;
